export class ApiUrls {
  api!: string
  commonsApi!: string
  cdn!: string
  socket!: string
  singApi!: string
  singSocket!: string
  stickerApiUrl!: string
  badgeApiUrl!: string
  signatureStickerApiUrl!: string
  textDonationUrl!: string
  itemStoreApiUrl!: string
  billingApiUrl!: string
  gwApi!: string
  studioApi!: string
  ivsApi!: string
  ivsSocket!: string
  authUrl!: string // url config 에는 없지만 사용하기 때문에 임의로 추가
}
